<div class="busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *fesListView="let rows of waypointTableRows">
      <table class="waypoint-table table table-striped table-bordered table-sm mb-0">
        <thead>
          <tr>
            <th fesSortField="waypointOrder" [sortType]="'numeric'">Waypoint#</th>
            <th fesSortField="waypointOrder" [sortType]="'numeric'">Segment</th>
            <th fesSortField="pointId">Point</th>
            <th fesSortField="latitude" [sortType]="'numeric'">Latitude</th>
            <th fesSortField="longitude" [sortType]="'numeric'">Longitude</th>
            <th fesSortField="type">Type</th>
          </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of rows;" [ngClass]="{'selected-row':selectedId && row.id==selectedId}">
            <td role="button" (click)="onPinClick(row.mapWaypoint)">
              {{row.waypointOrder}}
            </td>
            <td role="button" (click)="onPinClick(row.mapWaypoint)" class="waypoint-cell">
                <div class="d-flex justify-content-center">
                  <div *ngIf="row.segment" class="waypoint-div"
                      [ngStyle]="{'border-color': row.markerColor, 'background-color': selectedId === row.id ? 'yellow' : 'white'}">
                    {{row.segment}}
                  </div>
                </div>
            </td>
            <td style="text-align: start;">
              <a href="javascript:false" (click)="onShowPoint(row.pointId)">
                {{row.pointId}}
              </a>
            </td>
            <td>{{row.latitude|number:'1.6-6'}}</td>
            <td>{{row.longitude|number:'1.6-6'}}</td>
            <td>{{row.type}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>